import { json2csv } from './json2csv'
import { exportcsv } from './exportcsv'
import { getMeetingProvider } from './getMeetingProvider'
import { formatFileDuration, getDayAndMonth, getHour, timeAgo } from './formatDate'
import { parse } from 'tldts'

const truncateText = (text, limit) => {
  if (text.length > limit) {
    return text.slice(0, limit) + '...'
  }
  return text
}

const getPublicStorageUrl = (folder, filename) => {
  return `https://firebasestorage.googleapis.com/v0/b/${import.meta.env.VITE_FIREBASE_STORAGE_BUCKET}/o/${folder}%2F${filename}?alt=media`
}

function getDomain(url) {
  try {
    const result = parse(url)
    return result.domain || null
  } catch (e) {
    console.error('Invalid URL:', url)
    return null
  }
}

function isValidUrl(url) {
  const result = parse(url)
  return result.isIcann ?? false
}

export {
  json2csv,
  exportcsv,
  getMeetingProvider,
  getDayAndMonth,
  getHour,
  formatFileDuration,
  timeAgo,
  truncateText,
  getPublicStorageUrl,
  getDomain,
  isValidUrl,
}
